<template>
    <Navbar></Navbar>
    <div class="page-box">
        <div class="img-box page-banner">
            <img src="/assets/manufacture/transmission/chongqing/cq.jpg" alt=""></img>
            <div class="title-box">
                <div class="manufacture-t1">
                    变速器重庆工厂
                </div>
                <div class="manufacture-t2">
                    位于重庆市永川区，占地面积6.7万平方米<br />
                    主要生产9AT和9HAT总成，具备总装能力25万台/年，轴齿25万、P2分装20万。
                </div>
            </div>
        </div>

        <div class="page-title-box">
            <div class="page-t1">
                9（H）AT组装线
            </div>
        </div>

        <div class="page-sw">
            <div class="swiper-container kv-container swiper-item">
                <div class="swiper-wrapper">
                    
                    <div class="swiper-slide">
                        <div class="text-box ">
                            <div class="title">
                                EOL测试
                            </div>
                            <div class="destils">
                                ① 采用中央油站集体供油，本地油站精确控制的循环模式，控制更加准确，并减少了单台油站补油和更换滤芯的工作<br />
                                ② 采用工装料架安装传感器防错形式，避免了在测试位添加机构空间受限的矛盾
                            </div>
                        </div>
                        <div class="img-box">
                            <img src="/assets/manufacture/transmission/chongqing/cq1-1.jpg" alt="">
                        </div>
                    </div>

                </div>
                <div class="kv_pagination swiper-pagination left"></div>
            </div>
        </div>

        <div class="page-title-box">
            <div class="page-t1">
                HCM组装线
            </div>
        </div>

        <div class="page-sw">
            <div class="swiper-container kv-container swiper-item">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        <div class="img-box">
                            <img src="/assets/manufacture/transmission/chongqing/cq2-1.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                EOL测试
                            </div>
                            <div class="destils">
                                ① 采用测试台架集成油站一体化设计，节省了空间，也较少了管路较长引起的压降影响<br />
                                ② 测试台架集成甩油工位设计，降低了机器人运转节拍，已经保证了环境清洁度
                            </div>
                        </div>
                    </div>

                </div>
                <div class="kv_pagination swiper-pagination"></div>
            </div>
        </div>

    </div>
    <Footer></Footer>
</template>

<script setup>
import { ref, onMounted, onUnmounted, nextTick } from 'vue';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
import $ from 'jquery';

// 存储所有swiper实例，方便销毁
const swiperInstances = ref([]);

// 初始化所有轮播的核心函数
const initAllSwipers = async () => {
    await nextTick();

    const swiperElements = document.querySelectorAll('.swiper-item');

    swiperElements.forEach(el => {
        if (el) {
            const swiper = new Swiper(el, {
                speed: 1300,
                pagination: {
                    el: el.querySelector(".swiper-pagination"), // 绑定当前容器内的分页器
                    clickable: true,
                },
                direction: "horizontal",
                slidesPerView: 1,
                // spaceBetween: 20,
                simulateTouch: true,
                effect: 'fade',
                breakpoints: {
                    768: {},
                    1024: {}
                },
                // navigation: {
                //     nextEl: el.querySelector(".btn-r"),
                //     prevEl: el.querySelector(".btn-l"),
                //     disabledClass: 'swiper-button-disabled',
                // },
                on: {
                    // init: function () {
                    //     console.log('轮播初始化完成');
                    // },
                    // slideChangeTransitionStart(swiper) {
                    //     let swiperIndex = swiper.realIndex;
                    //     console.log('当前轮播索引：', swiperIndex);
                    // },
                },
            });
            swiperInstances.value.push(swiper); // 保存实例
        }
    });
};

// 页面挂载时初始化轮播
onMounted(() => {
    initAllSwipers();
});

// 页面卸载时销毁轮播实例（防止内存泄漏）
onUnmounted(() => {
    swiperInstances.value.forEach(swiper => {
        swiper.destroy(true, true);
    });
    swiperInstances.value = [];
});
</script>

<script>
export const pageConfig = {
    title: '变速器重庆工厂 - 蜂巢汽车官网',
    keywords: '蜂巢,蜂巢汽车,发动机,变速器,电子',
    description: '蜂巢汽车科技集团有限公司，是一家掌握从传统动力到混合动力再到纯电动力（含控制器）全领域动力总成、汽车智能化集成系统等核心技术的零部件企业，具备完整的软、硬件产业链；能为客户提供高效节能环保的汽车动力总成、智能化出行解决方案',
    outputPath: 'manufacture/tr/chongqing.html'
};

import { createApp } from 'vue';
import App from './chongqing.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/manufacture-detail.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./chongqing.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss"></style>
